import { type Enum } from '@webapp/infrastructure/types/Enum'

/**
 * Reference:
 * https://github.com/procurify/procurifydevelopment/blob/9ee7dc380e3b1eadf1c2971bbb139de8dea47b81/procurify/apps/common/models.py#L414
 */

export const AuditLogStatuses = {
  APPROVED: 'Approved',
  CANCELLED: 'Cancelled',
  CLOSED: 'Closed',
  CREATED: 'Created',
  EDITED: 'Edited',
  DELETED: 'Deleted',
  DENIED: 'Denied',
  PAID: 'Paid',
  PURCHASED: 'Purchased',
  RECEIVED: 'Received',
  REJECTED: 'Rejected',
  REMOVED: 'Removed',
  REOPENED: 'Reopened',
  SEND_PO: 'Send PO',
} as const

export type AuditLogStatusEnum = Enum<typeof AuditLogStatuses>
